import React from "react";
import Modal from "../../../Components/ExtraComponents/Modal";
// import BasicDataTable from "../../../Components/ExtraComponents/Datatable/BasicDataTable";
import Table from "../../../Components/ExtraComponents/Tables/FullDataTable";

import { fa_time, fDateTimeSuffix } from "../../../Utils/Date_formet";

const DetailsView = ({ showModal, setshowModal, tradeHistoryData }) => {
  const ft_time = (row) => {
    if (row.ft_time != undefined) {
      var milliseconds = row.ft_time * 1000;

      // Create a new Date object with the milliseconds
      var dateObject = new Date(milliseconds);

      // Get the year, month, day, hours, minutes, and seconds
      var year = dateObject.getFullYear();
      var month = ("0" + (dateObject.getMonth() + 1)).slice(-2);
      var day = ("0" + dateObject.getDate()).slice(-2);
      var hours = ("0" + dateObject.getHours()).slice(-2);
      var minutes = ("0" + dateObject.getMinutes()).slice(-2);
      var seconds = ("0" + dateObject.getSeconds()).slice(-2);

      // Form the date string
      var dateString =
        day +
        "/" +
        month +
        "/" +
        year +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds +
        " (IST)";

      // Output the result

      return dateString;
      //return row.ft_time
    } else {
      return "-";
    }
  };

  const columns = [
    {
      name: "Symbol",
      selector: (row) => row.symbol,
      sortable: true,
      width: "160px",
    },
    {
      name: "Exchange",
      selector: (row) => row.category,
      sortable: true,
      width: "160px",
    },
    {
      name: "Entry Type",
      selector: (row) => row.ordertype,
      cell: (row) => (
        <span className="text">
          {row.side === "BUY" || row.side === "LE" ? row.ordertype : "-"}
        </span>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Exit Type",
      selector: (row) => row.ordertype,
      cell: (row) => (
        <span className="text">
          {row.side === "SELL" || row.side === "SX" ? row.ordertype : "-"}
        </span>
      ),
      sortable: true,
      width: "160px",
    },

    {
      name: "Entry Price",
      selector: (row) => row.price,
      cell: (row) =>
        row.side === "LE" || row.side === "SE" || row.side === "BUY"
          ? parseFloat(row.price)
          : "-",
      sortable: true,
      width: "180px",
    },
    {
      name: "Exit Price",
      selector: (row) => row.price,
      cell: (row) =>
        row.side === "LX" || row.side === "SX" || row.side === "SELL"
          ? parseFloat(row.price)
          : "-",
      sortable: true,
      width: "180px",
    },
    {
      name: "Strategy",
      selector: (row) => row.strategy,
      sortable: true,
      width: "160px",
    },
    {
      name: "User Type",
      selector: (row) => row.usertype,
      cell: (row) => row?.usertype == "USER" ? row.username || "USER" : row?.usertype || "ADMIN",
      sortable: true,
      width: "130px",
    },
    {
      name: "Platform",
      selector: (row) => row.platform,
      cell: (row) => row?.platform || "-",
      sortable: true,
      width: "130px",
    },
    {
      name: "Market Type",
      selector: (row) => row.market_type,
      cell: (row) => row?.market_type || "-",
      sortable: true,
      width: "150px",
    },
   
    {
      name: "Signals Time",
      selector: (row) => row.createdAt,
      cell: (row) => (row.createdAt ? fDateTimeSuffix(row.createdAt) : "-"),
      sortable: true,
      width: "180px",
    },
    // {
    //   name: "Ft Time",
    //   selector: () => "",
    //   cell: (row) => ft_time(row),
    //   sortable: false,
    //   width: "180px",
    // },
  ];

  return (
    <div>
      <Modal
        isOpen={showModal}
        size="xl"
        title="Trade Details"
        hideBtn={true}
        handleClose={() => setshowModal(false)}
      >
        <Table columns={columns} data={tradeHistoryData?.ordersData} />
      </Modal>
    </div>
  );
};

export default DetailsView;
